/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/
import Backdrop from '@material-ui/core/Backdrop';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { createPortal } from 'react-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    left: 0,
    right: 0,
    overflowY: 'auto',
    position: 'fixed',
    top: 0,
    bottom: 0,
    overflowScrolling: 'touch',
    zIndex: theme.zIndex.drawer + 1,
  },
}));

export const InlineCardOverlay = () => {
  const classes = useStyles();
  const portalRoot = typeof document !== `undefined` ? document.getElementById('portal') : null;

  return createPortal(<Backdrop open={true} className={classes.root} />, portalRoot);
};
